<template>
  <div>
    <h3 class="sub-header">
      {{ "charts.itemCoverageChart.updateDate" | t }} {{ selectedDate | dateFormat("MMMM yyyy", false) }}
    </h3>
    <div class="tabs">
      <Tab
        v-for="tab in itemStatuses"
        :key="tab.name"
        :tabAttr="tab"
        :tabTotal="getTotal(tab.name)"
        :selected="isSelected(tab.name)"
        @selectedTabsChange="selectedTabsChange"
      />
    </div>
    <div v-if="showItemsCoverageDetails">
      <div class="download">
        <p class="downloadTitle">
          {{ "charts.itemCoverageChart.sampleData" | t
          }}<span class="downloadDesc">{{ "charts.itemCoverageChart.downloadReport" | t }}</span>
        </p>
        <button class="button is-pulled-right" type="button" :disabled="selectedTabs.length === 0" @click="download">
          {{ "charts.itemCoverageChart.downloadCSV" | t }}
        </button>
      </div>
      <VsTable
        :columns="itemCoverageDetails"
        :dataArray="itemDetailData"
        :options="{ hover: true, alignLeft: true }"
        :isLoading="itemDetails.isLoading"
      >
        <template v-slot="{ colValue }">
          <component :is="componentForColInfoKey(colValue.colInfo.key)" :rowData="colValue.data" />
        </template>
      </VsTable>
    </div>
    <VsNoChartData v-else height="350px">
      <template v-slot:header>
        <h2>{{ "charts.errorMessage.coverageError1" | t }}</h2>
      </template>
      <template v-slot:errorMessage>
        <p>{{ "charts.errorMessage.coverageError3" | t }}</p>
      </template>
    </VsNoChartData>
  </div>
</template>

<script>
import _ from "lodash";
import { ITEM_COVERAGE_STATUSES } from "@/misc/desktopCharts";
import { ITEM_COVERAGE_DETAILS } from "@/misc/tables";
import Tab from "./Tab";
import Category from "./Category";
import Status from "./Status";

export default {
  components: {
    Tab,
    Category,
    Status,
  },
  props: {
    tabTotals: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
    itemDetails: {
      type: Object,
      required: true,
    },
    downloadLink: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      itemStatuses: ITEM_COVERAGE_STATUSES,
      itemCoverageDetails: ITEM_COVERAGE_DETAILS,
      selectedTabs: ITEM_COVERAGE_STATUSES.map((item) => item.name),
    };
  },
  computed: {
    itemDetailData() {
      let data = [];
      for (let i = 0; i < this.selectedTabs.length; i++) {
        data.push(this.itemDetails[this.selectedTabs[i]]);
      }
      return _.flattenDeep(data)
        .sort((a, b) => new Date(b.updated) - new Date(a.updated))
        .slice(0, 10);
    },
    showItemsCoverageDetails() {
      return !this.itemDetails.isLoading && !this.itemDetails.isError;
    },
  },
  methods: {
    selectedTabsChange(updatedTab) {
      const { value, change } = updatedTab;
      if (change) {
        this.selectedTabs.push(value);
      } else {
        this.selectedTabs = this.selectedTabs.filter((t) => t !== value);
      }
    },
    getTotal(name) {
      return this.tabTotals.isError ? "N/A" : this.tabTotals[name];
    },
    isSelected(name) {
      return this.selectedTabs.includes(name);
    },
    download() {
      window.open(this.downloadLink);
    },
    componentForColInfoKey(colInfoKey) {
      if (colInfoKey === "product_type_id") return Category;
      if (colInfoKey === "statusKey") return Status;
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-header {
  margin-bottom: 10px;
}

.tabs {
  display: flex;
  justify-content: space-between;
}

.download {
  height: 80px;
  padding: 20px;
  border: $border-light;
  border-bottom: none;
  background: $white;

  .downloadTitle {
    float: left;
    font-size: 20px;

    .downloadDesc {
      color: $gray-600;
      font-size: 16px;
    }
  }

  .button {
    float: right;

    &:focus {
      border: 1px solid rgba(0, 0, 0, 0.4) !important;
    }
  }
}
</style>
<style lang="scss">
.vs-table {
  th,
  td {
    white-space: nowrap;
  }
}
</style>
